import React from 'react';

const Section = React.createClass({
  displayName: 'Section',
  render () {
    return null;
  }
});

export default Section;



// WEBPACK FOOTER //
// ./src/views/session/presentation/spectacle-ppa/src/section.jsx